if (!customElements.get('split-hero-banner')) {
  class SplitHeroBanner extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.shb-video-el');
      this.btn   = this.querySelector('.shb-pause-btn');
      if (!this.video || !this.btn) return;

      // Ensure autoplay works on iOS
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');

      this.btn.addEventListener('click', () => this._toggle());
      this.video.addEventListener('pause', () => this._sync());
      this.video.addEventListener('play',  () => this._sync());
      this._sync();
    }

    _toggle() {
      this.video.paused ? this.video.play() : this.video.pause();
    }

    _sync() {
      const paused = this.video.paused;
      this.btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      this.btn.querySelector('.shb-icon-pause').style.display = paused ? 'none' : '';
      this.btn.querySelector('.shb-icon-play').style.display  = paused ? '' : 'none';
    }
  }

  customElements.define('split-hero-banner', SplitHeroBanner);
}
